import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as t } from "../../../core/maybe.js";
import { b as e, c as i, r as s, j as r, m as h } from "../../../chunks/mat3.js";
import { c as n } from "../../../chunks/mat3f32.js";
import { f as u } from "../../../chunks/vec2f32.js";
import { DisplayObject as o } from "./DisplayObject.js";
import a from "./ImageryBitmapSource.js";
import d from "../../webgl/Texture.js";

function c(t) {
  return t && "render" in t;
}

function l(t) {
  return t && !("render" in t);
}

function x(t) {
  var e = document.createElement("canvas");
  return e.width = t.width, e.height = t.height, t.render(e.getContext("2d")), e;
}

function _(t, e, i) {
  var s = {
    target: 3553,
    pixelFormat: 6408,
    internalFormat: 6408,
    dataType: 5121,
    wrapMode: 33071
  };
  return e && i && (s.width = e, s.height = i), new d(t, s);
}

var g = /*#__PURE__*/function (_o) {
  _inherits(g, _o);

  var _super = _createSuper(g);

  function g() {
    var _this;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var e = arguments.length > 1 ? arguments[1] : undefined;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;

    _classCallCheck(this, g);

    _this = _super.call(this), _this.requestRenderOnSourceChangedEnabled = i, _this._textureInvalidated = !0, _this.stencilRef = 0, _this.coordScale = [1, 1], _this._height = void 0, _this.pixelRatio = 1, _this.resolution = 0, _this.rotation = 0, _this._source = null, _this._width = void 0, _this.x = 0, _this.y = 0, _this.blendFunction = e, _this.source = t, _this.requestRender = _this.requestRender.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(g, [{
    key: "destroy",
    value: function destroy() {
      this._texture && (this._texture.dispose(), this._texture = null);
    }
  }, {
    key: "isSourceScaled",
    get: function get() {
      return this.width !== this.sourceWidth || this.height !== this.sourceHeight;
    }
  }, {
    key: "height",
    get: function get() {
      return void 0 !== this._height ? this._height : this.sourceHeight;
    },
    set: function set(t) {
      this._height = t;
    }
  }, {
    key: "source",
    get: function get() {
      return this._source;
    },
    set: function set(t) {
      this._source = t, this.invalidateTexture();
    }
  }, {
    key: "sourceHeight",
    get: function get() {
      return this._source instanceof HTMLImageElement ? this._source.naturalHeight : this._source.height;
    }
  }, {
    key: "sourceWidth",
    get: function get() {
      return this._source instanceof HTMLImageElement ? this._source.naturalWidth : this._source.width;
    }
  }, {
    key: "width",
    get: function get() {
      return void 0 !== this._width ? this._width : this.sourceWidth;
    },
    set: function set(t) {
      this._width = t;
    }
  }, {
    key: "beforeRender",
    value: function beforeRender(t) {
      _get(_getPrototypeOf(g.prototype), "beforeRender", this).call(this, t), this.updateTexture(t.context);
    }
  }, {
    key: "invalidateTexture",
    value: function invalidateTexture() {
      this._textureInvalidated || (this._textureInvalidated = !0, this.requestRenderOnSourceChangedEnabled && this.requestRender());
    }
  }, {
    key: "_createTransforms",
    value: function _createTransforms() {
      return {
        dvs: n()
      };
    }
  }, {
    key: "setTransform",
    value: function setTransform(t) {
      var n = e(this.transforms.dvs),
          _t$toScreenNoRotation = t.toScreenNoRotation([0, 0], [this.x, this.y]),
          _t$toScreenNoRotation2 = _slicedToArray(_t$toScreenNoRotation, 2),
          o = _t$toScreenNoRotation2[0],
          a = _t$toScreenNoRotation2[1],
          d = this.resolution / this.pixelRatio / t.resolution,
          c = d * this.width,
          l = d * this.height,
          x = Math.PI * this.rotation / 180;

      i(n, n, u(o, a)), i(n, n, u(c / 2, l / 2)), s(n, n, -x), i(n, n, u(-c / 2, -l / 2)), r(n, n, u(c, l)), h(this.transforms.dvs, t.displayViewMat3, n);
    }
  }, {
    key: "setSamplingProfile",
    value: function setSamplingProfile(t) {
      this._texture && (t.mips && !this._texture.descriptor.hasMipmap && this._texture.generateMipmap(), this._texture.setSamplingMode(t.samplingMode));
    }
  }, {
    key: "bind",
    value: function bind(t, e) {
      this._texture && t.bindTexture(this._texture, e);
    }
  }, {
    key: "updateTexture",
    value: function updateTexture(e) {
      var i;
      if (!this.stage) return null == (i = this._texture) || i.dispose(), void (this._texture = null);
      if (!this._textureInvalidated) return;
      this._textureInvalidated = !1, this._texture || (this.source ? this._texture = _(e, this.sourceWidth, this.sourceHeight) : this._texture = _(e));
      var s = this.source;

      if (s) {
        if (this._texture.resize(this.sourceWidth, this.sourceHeight), c(s)) {
          if (s instanceof a) {
            var _e = s.getRenderedRasterPixels();

            this._texture.setData(t(_e) ? _e.renderedRasterPixels : null);
          } else this._texture.setData(x(s));
        } else l(s) && this._texture.setData(s);
        this.ready();
      } else this._texture.setData(null);
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      this.invalidateTexture();
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      this.invalidateTexture();
    }
  }]);

  return g;
}(o);

export { g as Bitmap, c as isImageSource, x as rasterize };